import React from "react";
import SidebarItem from "./SidebarItem";
import items from "../utils/sidebar.json";
import "../dashboard.css";
import Image from "../../assets/images/14logo.jpeg";
import { Link } from "react-router-dom";
import { getUser } from "../utils/common";
import { useMediaQuery } from "@mui/material";
import { IoPeopleSharp, IoSettingsOutline } from "react-icons/io5";

const Sidebar = () => {
  const user = getUser();
  const findType = user[0]?.type;

  const isTablet = useMediaQuery("(max-width: 960px)");

  let data = [];
  for (let i = 0; i < items.length; i++) {
    for (let j = 0; j < items[i]?.role?.length; j++) {
      if (items[i].role[j] === findType) {
        data.push(items[i]);
      }
    }
  }

  return (
    <div
      className={`${isTablet ? "w-[80px]" : "w-[200px]"
        } sidebar bg-black fixed z-20`}
    >
      <div className="flex items-left justify-left">
        <Link to="/boards" className="brand-logo">
          <img className="logo-abbr h-8 mt-6 mb-6 pl-4" src={Image} alt="" />
        </Link>
      </div>
      <div className="flex flex-col h-[90vh]">
        <div className="flex-1 h-full overflow-y-auto">
          {data.map((item, index) => (
            <SidebarItem key={index} item={item} />
          ))}
        </div>
        <div className="h-20 px-4 flex flex-col space-y-4">
          <Link to={"/attandance"}>
            <div className="flex items-center space-x-1 cursor-pointer text-white">
              <IoPeopleSharp />
              <span className="text-sm">Attandance</span>
            </div>
          </Link>
          <Link to={"/settings"}>
            <div className="flex items-center space-x-1 cursor-pointer text-white">
              <IoSettingsOutline />
              <span className="text-sm">Settings</span>
            </div>
          </Link>

        </div>
      </div>
    </div>
  );
};
export default Sidebar;
